import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import JoinWithUs from "../../Home/JoinWithUs";

import HeroDeFiLottery from "./HeroDeFiLottery";
import WhatIsDeFiLottery from "./WhatIsDeFiLottery";
import DeFiLotteryByXeer from "./DeFiLotteryByXeer";
import KeyFeaturesLottery from "./KeyFeaturesLottery";
import UseCasesLottery from "./UseCasesLottery";
import WhyChooseXeerLottery from "./WhyChooseXeerLottery";

function DeFiLottery() {
  return (
    <div id="smooth-content">
      <Header />
      <HeroDeFiLottery />
      <WhatIsDeFiLottery />
      <DeFiLotteryByXeer />
      <KeyFeaturesLottery />
      <UseCasesLottery />
      <div style={{ marginTop: "100px" }}>
        <JoinWithUs />
      </div>
      <WhyChooseXeerLottery />
      <Footer />
    </div>
  );
}

export default DeFiLottery;
